// Deposit fee model (mirrors the backend). Fees are added ON TOP of the wallet
// credit, so the wallet always gets the clean amount the player picked.
export const FAIRPLAY_FEE_PCT = 1;
export const GATEWAY_FEE_PCT = 3.5;
export const GATEWAY_FEE_FIXED_RANDS = 2; // R2 per transaction

export interface DepositBreakdown {
  credit: number;      // lands in wallet (clean)
  fairplay: number;    // FairPlay's cut
  gateway: number;     // estimated payment-gateway cost
  totalFee: number;
  total: number;       // what the player actually pays
}

// Work in cents to match the backend's rounding, then convert back to Rands.
export function depositBreakdown(creditRands: number): DepositBreakdown {
  const credit = Math.round(creditRands * 100);
  const fairplay = Math.round((credit * FAIRPLAY_FEE_PCT) / 100);
  const gateway =
    Math.round(((credit + fairplay) * GATEWAY_FEE_PCT) / 100) + GATEWAY_FEE_FIXED_RANDS * 100;
  const totalFee = fairplay + gateway;
  return {
    credit: credit / 100,
    fairplay: fairplay / 100,
    gateway: gateway / 100,
    totalFee: totalFee / 100,
    total: (credit + totalFee) / 100,
  };
}
